import React from 'react';
import { Collapse, Table, Typography, Tag } from 'antd';
import { useLanguage } from '../../../../../contexts/LanguageContext';

const { Text } = Typography;

const formatAmount = (v, currency = 'HKD') => {
  const n = Number(v) || 0;
  return `${currency} ${n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

const StatementCustomerBlock = ({ customer, exportRef }) => {
  const { t } = useLanguage();

  const invoiceColumns = [
    { title: t('reports.commerce.orderNo') || '訂單編號', dataIndex: 'orderNo', key: 'orderNo', width: 120 },
    {
      title: t('reports.commerce.deliveryDate') || '送貨日期',
      dataIndex: 'deliveryDate',
      key: 'deliveryDate',
      width: 120,
      render: (v) => (v ? String(v).slice(0, 10) : '—')
    },
    {
      title: t('reports.commerce.amount') || '金額',
      dataIndex: 'totalAmount',
      key: 'totalAmount',
      align: 'right',
      render: (v, r) => formatAmount(v, r.currency)
    },
    { title: t('reports.commerce.paymentTerm') || '付款條款', dataIndex: 'paymentTerm', key: 'paymentTerm', ellipsis: true },
    { title: t('commerceSalesOrders.status') || '狀態', dataIndex: 'status', key: 'status', width: 100, render: (v) => <Tag>{v}</Tag> },
    { title: t('reports.commerce.lineCount') || '明細行數', dataIndex: 'lineCount', key: 'lineCount', width: 90, align: 'right' }
  ];

  const monthPanels = (customer.months || []).map((month) => ({
    key: month.monthKey,
    label: (
      <span>
        <Text strong>{month.monthLabel}</Text>
        <Text type="secondary" style={{ marginLeft: 12 }}>
          {t('reports.commerce.monthTotal') || '月小計'}: {formatAmount(month.monthTotal)}
        </Text>
      </span>
    ),
    children: (
      <Table
        rowKey="orderId"
        size="small"
        pagination={false}
        columns={invoiceColumns}
        dataSource={month.invoices || []}
        scroll={{ x: 800 }}
      />
    )
  }));

  return (
    <div ref={exportRef} style={{ marginBottom: 16 }}>
      <Collapse
        defaultActiveKey={(customer.months || []).map((m) => m.monthKey)}
        items={[
          {
            key: customer.customerId || customer.customerNo || 'anon',
            label: (
              <div>
                <Text strong>{customer.customerName || '—'}</Text>
                {customer.customerNo && (
                  <Text type="secondary" style={{ marginLeft: 8 }}>
                    {customer.customerNo}{customer.branchNo ? ` / ${customer.branchNo}` : ''}
                  </Text>
                )}
                {customer.paymentTerm && (
                  <Tag style={{ marginLeft: 8 }}>{customer.paymentTerm}</Tag>
                )}
                <Text type="secondary" style={{ float: 'right' }}>
                  {t('reports.commerce.customerTotal') || '客戶小計'}: {formatAmount(customer.customerTotal)}
                </Text>
              </div>
            ),
            children: <Collapse items={monthPanels} defaultActiveKey={(customer.months || []).map((m) => m.monthKey)} />
          }
        ]}
      />
    </div>
  );
};

export default StatementCustomerBlock;
